import React, { ReactNode } from "react";
import { ErrorMessage, Field, FieldInputProps } from "formik";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import style from "./FormikSelect.module.css";

export interface FormikSelectItem {
  label: string;
  value: string | number;
}

interface FormikSelectProps {
  value?: string;
  name: string;
  items: FormikSelectItem[];
  label: string;
  required?: boolean;
  multiple?: boolean;
  onChange?: any;
  err?: any;
}

interface MaterialUISelectFieldProps extends FieldInputProps<string> {
  errorString?: string;
  children: ReactNode;
  label: string;
  required: boolean;
}

const MaterialUISelectField: React.FC<MaterialUISelectFieldProps> = ({
  errorString,
  label,
  children,
  value,
  name,
  onChange,
  onBlur,
  required,
}) => {
  return (
    <FormControl variant="standard" required={required} fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select name={name} onChange={onChange} onBlur={onBlur} value={value}>
        {children}
      </Select>
      <FormHelperText>{errorString}</FormHelperText>
    </FormControl>
  );
};

const FormikSelect: React.FC<FormikSelectProps> = ({
  name,
  items,
  required = false,
  label,
  multiple = false,
  onChange,
  err,
}) => {
  return (
    <div className={style.FormikSelect}>
      <Field
        name={name}
        as={MaterialUISelectField}
        errorString={<ErrorMessage name={name} />}
        required={required}
        multiple={multiple}
        label={label}
        error={err}
      >
        {items.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Field>
    </div>
  );
};

export default FormikSelect;
